export const getResourceUrlHack = (path)=>{
    // workaround until resource URL is properly respected for recipe thumbnails
    let baseResourcesUrl = 'http://localhost';
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const resourcesUrl = phoenix.runtimeConfig.RESOURCES_URL;
        if (resourcesUrl) {
            baseResourcesUrl = resourcesUrl;
        }
    } catch (ignored) {}
    return new URL(path, baseResourcesUrl).href;
};

//# sourceMappingURL=resources.js.map